import { useEffect, useState } from "react"
import { req, reqPoll } from "./ServerUtils";
import { Button } from "@mui/material";

export function Designs({}) {
    const [designs, setDesigns] = useState([]);
    const [page, setPage] = useState(1);

    useEffect(() => {
        req('/admin/html_designs').then(data => setDesigns(data.designs || []));
    }, [])

    function loadMore() {
        req('/admin/html_designs?page=' + (page + 1)).then(data => {
            setDesigns([...designs, ...data.designs]);
            setPage(page + 1);
        });
    }

    function preview(design) {
        console.log(design)
        const urls = design.metainfo?.png_urls;
        if (!urls || urls.length === 0) return '';
        const urlInfo = urls[0];
        if (urlInfo && urlInfo.bucket && urlInfo.key)
            return "https://" + urlInfo.bucket + '/' + urlInfo.key;
        return '';
    }
    
    return (
        <div>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: 20,
                padding: 20,
            }}>
            {designs.map((design, i) => design.email != 'dev@makemybrand.ai' && design.email != 'ducktyper01@gmail.com' &&(
                    <div key={i} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10,
                        padding: 10,
                        border: '1px solid #ddd',
                        borderRadius: 5,
                        alignItems: 'center',

                        width: 100,
                        overflow: 'hidden',
                    }}>
                        <img src={preview(design)} alt="Design Preview" style={{ 
                            // width: 100,
                            width: 100,
                            objectFit: 'cover',
                            cursor: 'pointer'
                        }} onClick={() => {
                            window.open('https://app.makemybrand.ai/design/' + design.id, '_blank');
                        }}/>
                        <span>{design.email}</span>
                        <span>{design.id}</span>
                        <span>{meta(design.metainfo)}</span>
                        {design?.metainfo?.input?.title && <span>Title: {design?.metainfo?.input?.title}</span>}
                        <span>Created at: {design.created_at}</span>
                        <span><a href='#' onClick={() => {
                            const data = {
                                design_id: design.id
                            }
                            reqPoll('/regenerate', 'POST', JSON.stringify(data)).then(res => {
                                alert('Design regenerated successfully');
                                console.log(res);
                            });
                        
                        }}>Regenerate</a></span>
                        
                    </div>
                ))}
            </div>
            <div style={{
                padding: 10,
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Button
                    variant="outlined"
                    style={{ textTransform: 'none' }}
                    onClick={loadMore}
                    >
                    Load More
                </Button>

            </div>
        </div>
    )
}

function meta(metainfo) {
    let j = JSON.parse(JSON.stringify(metainfo));
    delete j.html_urls;
    delete j.png_urls;
    if (metainfo?.input?.url) {
        return <a href={metainfo.input.url} target="_blank">Link</a>
    }
    if (metainfo?.input?.subject) {
        return metainfo.input.subject;
    }
    return ''
    // return JSON.stringify(j);
}